module.exports = __webpack_public_path__ + "img/icon-24-ic-chev-w.cb568ec0.svg";